module.exports = __webpack_public_path__ + "img/w2-b1.993275fb.jpg";